import { StyleRules } from '@material-ui/core/styles';
import { ToggleButtonGroupClassKey } from '@material-ui/lab/ToggleButtonGroup';
import { core as theme } from '../styles/core';

export const MuiToggleButtonGroup: Partial<StyleRules<
  ToggleButtonGroupClassKey
>> = {
  groupedHorizontal: {
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
  },
};
